<script setup lang="ts">
import type { IconName } from "../Icon/icons";
import VIcon from "../Icon/VIcon.vue";

// One tappable row in a phone bottom sheet: a tinted icon tile, the label and optional trailing content.
const {
  icon = undefined,
  label,
  variant = "default",
  chevron = false,
  badge = null,
} = defineProps<{
  icon?: IconName
  label: string
  variant?: "default" | "danger"
  chevron?: boolean
  badge?: number | string | null
}>();
</script>

<template>
  <button
    type="button"
    class="flex items-center gap-3 w-full min-h-[52px] px-4 py-2 text-left text-[15px] transition-colors active:bg-gray-100 dark:active:bg-dark-700"
    :class="variant === 'danger' ? 'text-red-500' : 'text-gray-800 dark:text-gray-100'"
  >
    <span
      class="flex items-center justify-center w-8 h-8 shrink-0 rounded-lg text-[15px]"
      :class="variant === 'danger'
        ? 'bg-red-50 text-red-500 dark:bg-red-900/30 dark:text-red-400'
        : 'bg-primary-50 text-primary-500 dark:bg-primary-900/30 dark:text-primary-400'"
    >
      <slot name="icon">
        <VIcon v-if="icon" :name="icon" />
      </slot>
    </span>
    <span class="min-w-0 flex-1 truncate">
      <slot>{{ label }}</slot>
    </span>
    <span
      v-if="badge"
      class="flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-red-500 text-white text-xs font-bold leading-none"
    >
      {{ badge }}
    </span>
    <slot name="trailing" />
    <VIcon v-if="chevron" name="chevron-right" class="text-xs text-gray-300 dark:text-dark-400" />
  </button>
</template>
